module.exports = __webpack_public_path__ + "img/symbol_0.731ae2bf.png";